<template>
<v-row>

    <v-col
    >
        <v-text-field
            :label="label"
            prefix="$"
            :value="amount"
            :rules="[rule_amount]"
            v-on:input="onChangeAmount"
            ref="amount"
        />

    </v-col>

    <v-col
        style="max-width: 120px"
    >
        <v-select
            :items="items"
            :value="currency_code"
            v-on:change="onChangeCurrency"
        />
    </v-col>

</v-row>
</template>

<script>
export default {
    props: {
        
        label: {
            type: String,
            default: function() { return 'Amount'; }
        },

        value: {
            type: String,
            default: function() { return 'USD0.00'; }
        },
    },

    data() {
        return {
            items: [
                {'text': 'USD', 'value': 'USD'},
                {'text': 'CAD', 'value': 'CAD'},
            ],

            amount: null,
            currency_code: null,
        };
    },

    mounted () {
        this.amount = this.getAmountFromValue();
        this.currency_code = this.getCurrencyCodeFromValue();
    },

    methods: {
        getCurrencyCodeFromValue() {
            if ( this.value == null || this.value.length < 3 ) return 'USD';
            
            return this.value.substring(0,3).toUpperCase();
        },

        getAmountFromValue()
        {
            if ( this.value == null || this.value.length <= 3 ) return '0.00';

            let amount = this.value.substring(3);
            return amount;
        },

        onChangeCurrency(new_currency_code)
        {
            this.$emit('input', new_currency_code+this.amount);
        },

        extractAmountFromInput(value)
        {
             if ( value == null ) 
                return null;

            value = value.trim();
            if ( value.length == 0 ) 
                return null;

            value = value.replace(/\$/g,'');

            let as_float = parseFloat(value);
            if ( isNaN(as_float) ) 
                return null;

            return as_float;
        },

        rule_amount(value)
        {
            // Empty is a valid value...
            if ( value == null ) return true;

            value = value.trim();
            if ( value.length == 0 ) return true;

            value = value.replace(/\$/g,'');

            let as_float = parseFloat(value);
            if ( isNaN(as_float) ) return 'Invalid Amount: Enter a number';

            return true;
        },

        onChangeAmount(value)
        {
            let amount = this.extractAmountFromInput(value);

            if ( amount == null )
            {
                //this.$emit('input', null);
                return;
            }

            this.$emit('input',this.currency_code+amount);
        },

        focus()
        {
            this.$refs['amount'].focus();
        },
    },

    watch: {
        value(newValue, oldValue) {
            this.amount = this.getAmountFromValue();
            this.currency_code = this.getCurrencyCodeFromValue();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>